<!--
Author: TangChen
Date: 2019-04-08
Desc: IE9文件上传组件
 -->
<template>
    <div class="comp-data-up comp">
        <form id="uploadForm">
            <div class="layui-form-item">
                <div class="k-upload-msg">
                    1、本人有效身份证件
                    <div class="k-upload-btn">
                        <label for="front">手持身份证照片（正面）</label>
                        <input
                            id="front"
                            type="file"
                            name="front"
                            class="k-file-btn"
                            index="1"
                            v-on:change="previewImage"
                        >
                    </div>
                    <div class="k-upload-btn">
                        <label for="back">手持身份证照片（反面）</label>
                        <input
                            id="back"
                            type="file"
                            name="back"
                            class="k-file-btn"
                            index="2"
                            v-on:change="previewImage"
                        >
                    </div>
                </div>
            </div>
            <div class="layui-form-item layui-row">
                <div id="preview1" class="k-preview layui-col-sm4">
                    <img id="imghead1">
                </div>
                <div id="preview2" class="k-preview layui-col-sm4">
                    <img id="imghead2">
                </div>
            </div>
            <div class="layui-form-item">
                <div class="k-upload-msg">
                    2、金融机构出具的金融资产不低于300万元的资产证明（加盖金融机构业务专用章），或者最近3年个人年均收入不低于30万元的证明（加盖公司公章）
                    <div class="k-upload-btn">
                        <label for="asset">资产证明扫描件</label>
                        <input
                            id="asset"
                            type="file"
                            name="asset"
                            index="3"
                            class="k-file-btn"
                            v-on:change="previewImage"
                        >
                    </div>
                </div>
            </div>
            <div class="layui-form-item layui-row">
                <div id="preview3" class="k-preview layui-col-sm8">
                    <img id="imghead3">
                </div>
            </div>
            <div class="layui-form-item">
                <div class="k-upload-msg">
                    3、相关金融机构出具的最近2年证券、基金、期货、黄金、外汇等投资记录原件（如对账单或交易流水，加盖金融机构业务专用章），或最近2年从事金融产品设计、投资、风险管理及相关工作经历的工作证明（加盖单位公章）
                    <div class="k-upload-btn">
                        <label for="invest">投资或工作证明扫描件</label>
                        <input
                            id="invest"
                            type="file"
                            name="invest"
                            class="k-file-btn"
                            index="4"
                            v-on:change="previewImage"
                        >
                    </div>
                </div>
            </div>
            <div class="layui-form-item layui-row">
                <div id="preview4" class="k-preview layui-col-sm8">
                    <img id="imghead4">
                </div>
            </div>
        </form>
        <p>4、注意：上传的图片大小每个不能超过1.5M，格式类型只支持bmp，jpg，jpeg，png</p>
        <div class="layui-form-item k-margin-top40 k-padding-10 k-text-center">
            <el-button type="primary" class="medium" v-on:click="initForm">
                上传
            </el-button>
            <el-button class="medium" v-on:click="$router.back()">
                还未准备好
            </el-button>
        </div>
    </div>
</template>
<script>
import $ from "jquery";
export default {
    name: "DataUp",
    data () {
        return {
            uploadText: []
        };
    },
    mounted () {
        const _this = this;
        document.getElementById("uploadForm").reset(); // 清除浏览器记录的上次记录
        $("#uploadForm").on("change", ".k-file-btn", function (e) {
            var x = $(this).attr("id");
            var ofCourse = $("label[for=" + x + "]");
            if (!_this.uploadText[x]) {
                _this.uploadText[x] = ofCourse.text();
            }
            // 输出选中结果
            if (this.value && this.value !== "") {
                ofCourse.html(_this.uploadText[x] + "(已上传)");
            } else {
                ofCourse.html(_this.uploadText[x]);
            }
        });
    },
    created () {
        let _this = this;
        jQuery.extend({
            createUploadIframe: function (id, uri) {
                // create frame
                var frameId = "jUploadFrame" + id;
                var iframeHtml = "<iframe id=\"" + frameId + "\" name=\"" + frameId + "\" style=\"position:absolute; top:-9999px; left:-9999px\"";
                if (window.ActiveXObject) {
                    if (typeof uri === "boolean") {
                        iframeHtml += " src=\"" + "javascript:false" + "\"";
                    } else if (typeof uri === "string") {
                        iframeHtml += " src=\"" + uri + "\"";
                    }
                }
                iframeHtml += " />";
                jQuery(iframeHtml).appendTo(document.body);

                return jQuery("#" + frameId).get(0);
            },
            createUploadForm: function (id, fileElementId, data) {
                // create form
                var formId = "jUploadForm" + id;
                // var fileId = 'jUploadFile' + id
                var form = jQuery("<form  action=\"\" method=\"POST\" name=\"" + formId + "\" id=\"" + formId + "\" enctype=\"multipart/form-data\"></form>");
                if (data) {
                    for (let i in data) {
                        jQuery(
                            "<input type=\"hidden\" name=\"" + i + "\" value=\"" +
                            data[i] + "\" />").appendTo(form);
                    }
                }
                for (let i = 0; i < fileElementId.length; i++) {
                    var oldElement = jQuery("#" + fileElementId[i]);
                    var newElement = jQuery(oldElement).clone();
                    jQuery(oldElement).attr("id", fileElementId[i]);
                    jQuery(oldElement).attr("name", fileElementId[i]);
                    jQuery(oldElement).before(newElement);
                    jQuery(oldElement).appendTo(form);
                }
                // set attributes
                jQuery(form).css("position", "absolute");
                jQuery(form).css("top", "-1200px");
                jQuery(form).css("left", "-1200px");
                jQuery(form).appendTo("body");
                return form;
            },
            ajaxFileUpload: function (s) {
                s = jQuery.extend({}, jQuery.ajaxSettings, s);
                var id = new Date().getTime();
                var _data = {};
                s.data = _data;
                let form = jQuery.createUploadForm(id, s.fileElementId, (typeof (s.data) === "undefined" ? false : s.data));
                jQuery.createUploadIframe(id, s.secureuri);
                var frameId = "jUploadFrame" + id;
                var formId = "jUploadForm" + id;
                // Watch for a new set of requests
                if (s.global && !jQuery.active++) {
                    jQuery.event.trigger("ajaxStart");
                }
                var requestDone = false;
                // Create the request object
                var xml = {};
                if (s.global) { jQuery.event.trigger("ajaxSend", [xml, s]); }
                // Wait for a response to come back
                var uploadCallback = function (isTimeout) {
                    var io = document.getElementById(frameId);
                    try {
                        if (io.contentWindow) {
                            xml.responseText = io.contentWindow.document.body ? io.contentWindow.document.body.innerHTML : null;
                            xml.responseXML = io.contentWindow.document.XMLDocument ? io.contentWindow.document.XMLDocument : io.contentWindow.document;
                        } else if (io.contentDocument) {
                            xml.responseText = io.contentDocument.document.body ? io.contentDocument.document.body.innerHTML : null;
                            xml.responseXML = io.contentDocument.document.XMLDocument ? io.contentDocument.document.XMLDocument : io.contentDocument.document;
                        }
                    } catch (e) {
                        jQuery.error(e);
                    }
                    if (xml || isTimeout === "timeout") {
                        requestDone = true;
                        var status = "";
                        try {
                            status = isTimeout !== "timeout" ? "success" : "error";
                            // Make sure that the request was successful or notmodified
                            if (status !== "error") {
                                // process the data (runs the xml through httpData regardless of callback)
                                var data = jQuery.uploadHttpData(xml, s.dataType);
                                // If a local callback was specified, fire it and pass it the data
                                if (s.success) { s.success(data, status); }
                                // Fire the global callback
                                if (s.global) { jQuery.event.trigger("ajaxSuccess", [xml, s]); }
                            } else { jQuery.error(status); }
                        } catch (e) {
                            status = "error";
                            jQuery.error(status);
                        }

                        // The request was completed
                        if (s.global) { jQuery.event.trigger("ajaxComplete", [xml, s]); }

                        // Handle the global AJAX counter
                        if (s.global && !--jQuery.active) { jQuery.event.trigger("ajaxStop"); }

                        // Process result
                        if (s.complete) { s.complete(xml, status); }

                        jQuery(io).unbind();

                        setTimeout(function () {
                            try {
                                jQuery(io).remove();
                                jQuery(form).remove();
                            } catch (e) {
                                jQuery.error(e);
                            }
                        }, 100);
                        xml = null;
                    }
                };
                // 超时计算
                if (s.timeout > 0) {
                    setTimeout(function () {
                        if (!requestDone) uploadCallback("timeout");
                    }, s.timeout);
                }
                try {
                    form = jQuery("#" + formId);
                    const _session = _this.$cache.getSessionToken();
                    jQuery(form).attr("action", s.url + "?token=" + _session + "&g_systemtype=2");
                    jQuery(form).attr("method", "POST");
                    jQuery(form).attr("target", frameId);
                    if (form.encoding) {
                        jQuery(form).attr("encoding", "multipart/form-data");
                    } else {
                        jQuery(form).attr("enctype", "multipart/form-data");
                    }
                    jQuery(form).submit();
                } catch (e) {
                    jQuery.error(e);
                }

                jQuery("#" + frameId).on("load", function () { uploadCallback(); });
                return {
                    abort: function () {
                    }
                };
            },
            uploadHttpData: function (r, type) {
                var ajaxResult = {};
                var data = !type;
                data = type === "xml" || data ? r.responseXML : r.responseText;
                if (type === "json") {
                    try {
                        data = $.parseJSON(data.replace(/<.*?>/ig, ""));
                        ajaxResult.code = data.code;
                        ajaxResult.datas = data.record;
                        ajaxResult.msg = data.msg;
                    } catch (e) {
                        ajaxResult.code = -1;
                        ajaxResult.msg = "Parse json data failed: " + e.msg;
                        ajaxResult.datas = data.record;
                    }
                }
                return ajaxResult;
            }
        });
    },
    methods: {
        initForm: function () {
            var _this = this;
            var sameNameMap = {};
            var flag = true;
            var arrId = [];
            $.each($(".k-file-btn"), function (index, element) {
                var x = element.value.split(".")[1];
                if (element.value.trim() === "") {
                    flag = false;
                    let t = $(".k-upload-btn").eq(index).find("input").attr("id");
                    _this.$message.warning((_this.uploadText[t] ? _this.uploadText[t] : "存在") + "文件未上传");
                    return false;
                }
                if (x && "jpg,jpeg,png,bmp".indexOf(x) === -1) {
                    flag = false;
                    let t = $(".k-upload-btn").eq(index).find("input").attr("id");
                    _this.$message.warning(_this.uploadText[t] + "文件类型不符合要求");
                    return false;
                }
                if (sameNameMap["_" + element.value] && index < 4) {
                    flag = false;
                    let t = $(".k-upload-btn").eq(index).find("input").attr("id");
                    _this.$message.warning(_this.uploadText[t] + "文件名重复！");
                    return false;
                } else {
                    arrId[arrId.length] = element.name;
                    sameNameMap["_" + element.value] = true;
                }
            });
            if (flag) {
                _this.ajaxUpload(arrId);
            }
        },
        ajaxUpload: function (arrId) {
            var _this = this;
            var baseUrl = "api/v1/acct/changetype/upload";
            $.ajaxFileUpload({
                url: baseUrl,
                secureuri: false,
                fileElementId: arrId,
                async: true,
                dataType: "json",
                enctype: "multipart/form-data",
                success: function (res, status) {
                    if (res.code === "0000000") {
                        _this.$emit("success", true);
                    } else {
                        $(".k-preview img").attr("src", "");
                        if (res.code === "9999999") {
                            _this.$store.dispatch("logout").then(res => {
                                _this.$alert("您尚未登录，或已长时间未进行操作，为了保障您的账户安全，请刷新后重新登录!", "", {
                                    confirmButtonText: "确定",
                                    type: "warning",
                                    callback: action => {
                                        _this.$router.push("/");
                                    }
                                }).then(() => {
                                    return false;
                                }).catch(() => {
                                    return false;
                                });
                            });
                            return;
                        }
                        _this.$message.error(res.msg);
                    }
                }
            });
        },
        previewImage: function (event) {
            var _this = this;
            const file = event || window.event;
            const num = $("#" + file.target.id).attr("index");
            var MAXWIDTH = 320;
            var MAXHEIGHT = 800;
            var div = document.getElementById("preview" + num);
            div.style.display = "inline-block";
            if (file.target.files && file.target.files[0]) {
                div.innerHTML = "<img id=imghead" + num + ">";
                let img = document.getElementById("imghead" + num);
                img.onload = function () {
                    var rect = _this.clacImgZoomParam(MAXWIDTH, MAXHEIGHT, img.offsetWidth, img.offsetHeight);
                    img.width = rect.width;
                    img.height = rect.height;
                };
                var reader = new FileReader();
                reader.onload = function (evt) {
                    img.src = evt.target.result;
                };
                reader.readAsDataURL(file.target.files[0]);
            } else {
                var sFilter = "filter:progid:DXImageTransform.Microsoft.AlphaImageLoader(sizingMethod=scale,src=\"";
                var other = "\",sizingMethod=scale)";
                var src = _this.getPath(file.target);
                // div.innerHTML = '<img id=imghead' + num + '>'
                let img = document.getElementById("imghead" + num);
                // img.setAttribute("src",src);
                img.style.filter = "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='" + src + "',sizingMethod=image)";
                var rect = _this.clacImgZoomParam(MAXWIDTH, MAXHEIGHT, img.offsetWidth, img.offsetHeight);
                // status = ('rect:' + rect.top + ',' + rect.left + ',' + rect.width + ',' + rect.height)
                div.innerHTML = "<div id=divhead" + num + " style='width:" + rect.width + "px;height:" + rect.height + "px;" + sFilter + src + other + "\"'></div>";
            }
        },
        getPath: function (obj) { // 参数obj为input file对象
            if (obj) {
                if (window.navigator.userAgent.indexOf("MSIE") >= 1) {
                    obj.select();
                    window.parent.document.body.focus();
                    return document.selection.createRange().htmlText;
                } else if (window.navigator.userAgent.indexOf("Firefox") >= 1) {
                    if (obj.files) {
                        return obj.files.item(0).getAsDataURL();
                    }
                    return obj.value;
                }
                return obj.value;
            }
        },
        clacImgZoomParam: function (maxWidth, maxHeight, width, height) {
            var param = { top: 0, left: 0, width: width, height: height };
            if (width > maxWidth || height > maxHeight) {
                const rateWidth = width / maxWidth;
                const rateHeight = height / maxHeight;

                if (rateWidth > rateHeight) {
                    param.width = maxWidth;
                    param.height = Math.round(height / rateWidth);
                } else {
                    param.width = Math.round(width / rateHeight);
                    param.height = maxHeight;
                }
            }

            param.left = Math.round((maxWidth - param.width) / 2);
            param.top = Math.round((maxHeight - param.height) / 2);
            return param;
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-data-up {
    padding: 40px 50px;
    .k-upload-msg {
        line-height: 30px;
    }
    .layui-form-item {
        margin-bottom: 0;
    }
    .layui-form-item .k-preview {
        margin: 10px 0;
    }
    .k-upload-btn {
        display: inline-block;
        position: relative;
    }
    .k-upload-btn:nth-child(2),
    .k-preview:nth-child(2) {
        margin-left: 20px;
    }
    .k-upload-btn label {
        height: 30px;
        display: block;
        background: #006eaa;
        color: #ffffff;
        border-radius: 4px 4px;
        -webkit-border-radius: 4px 4px;
        padding: 0 15px;
    }
    .k-upload-btn input[type="file"] {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        opacity: 0;
        filter: alpha(opacity=0);
    }
    .k-margin-top40 {
        margin-top: 40px;
    }
}
</style>
